import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'

import {
  COMPANY_DETAIL,
  COMPANY_SEARCH,
  COMPANY_SEARCH_WITH_DETAIL,
  JOB_DETAIL,
  JOB_DETAIL_RESULTS_ONLY,
  JOB_PREVIEW,
  JOB_PREVIEW_RESULTS_ONLY,
  JOB_SEARCH,
  JOB_SEARCH_WITH_DETAIL
} from '@/page/constants'
import { enforcePageType } from '@/page/store/actions'
import { NEW_SEARCH_TRIGGER_LOCATION, newSearch } from '@/results/store/actions'
import { COMPANY, JOB } from '@/search/constants'
import { job, company, navigateUp } from '@/search/store/actions'

import { DEFAULT_TYPE } from './defaultState'

/**
 * @return {PageType}
 */
const type = handleActions({
  [job.setSelectedId]: (state) => {
    switch (state) {
      case JOB_DETAIL_RESULTS_ONLY:
      case JOB_DETAIL:
        return JOB_DETAIL
      case JOB_PREVIEW_RESULTS_ONLY:
      case JOB_PREVIEW:
        return JOB_PREVIEW
      default:
        return JOB_SEARCH_WITH_DETAIL
    }
  },
  [company.setSelectedId]: (state) => {
    return COMPANY_SEARCH_WITH_DETAIL
  },
  [newSearch.request]: (state, { payload: { type }, meta: { trigger } }) => {
    if (trigger === NEW_SEARCH_TRIGGER_LOCATION) {
      return state
    }
    switch (type) {
      case JOB:
        return JOB_SEARCH
      case COMPANY:
        return COMPANY_SEARCH
      default:
        return state
    }
  },
  [navigateUp]: (state) => {
    switch (state) {
      case JOB_DETAIL:
        return JOB_DETAIL_RESULTS_ONLY
      case JOB_PREVIEW:
        return JOB_PREVIEW_RESULTS_ONLY
      case JOB_SEARCH_WITH_DETAIL:
        return JOB_SEARCH
      case COMPANY_DETAIL:
      case COMPANY_SEARCH_WITH_DETAIL:
        return COMPANY_SEARCH
      default:
        return state
    }
  },
  [enforcePageType]: (_, { payload: pageType }) => pageType
}, DEFAULT_TYPE)

/**
 * @return {{type: PageType}}
 */
export default combineReducers({
  type
})
